import { createSlice } from "@reduxjs/toolkit";
import { acceptEsignAgreementAPI } from "../../../services/guestUsers/guestUserAllAPIService";

const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
};

const acceptEsignAgreementSlice = createSlice({
  name: "acceptEsignAgreement",
  initialState: data,
  reducers: {
    acceptEsignAgreementInfo(state) {
      state.isLoading = true;
    },
    acceptEsignAgreementSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = "";
    },
    acceptEsignAgreementFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
      state.data = null;
    },
    acceptEsignAgreementReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
    },
  },
});

export const acceptEsignAgreementHandler = (payload) => async (dispatch) => {
  try {
    dispatch(acceptEsignAgreementSliceAction.acceptEsignAgreementInfo());
    const response = await acceptEsignAgreementAPI(payload);
    dispatch(
      acceptEsignAgreementSliceAction.acceptEsignAgreementSuccess(response),
    );
    return response;
  } catch (e) {
    dispatch(
      acceptEsignAgreementSliceAction.acceptEsignAgreementFailure(e),
    );
    throw e;
  }
};

export default acceptEsignAgreementSlice.reducer;
export const acceptEsignAgreementSliceAction =
  acceptEsignAgreementSlice.actions;
